import { Message } from "../../apis/copilot/types";

export const mergeMessages = (
  currentMessages: Message[],
  newMessages: Message[]
) => {
  const updatedMessages = [...currentMessages];

  newMessages.forEach((newMessage) => {
    const idx = updatedMessages.findIndex((msg) => msg.id === newMessage.id);
    if (idx === -1) {
      updatedMessages.push(newMessage);
    } else {
      updatedMessages[idx] = {
        ...updatedMessages[idx],
        payload: {
          ...updatedMessages[idx].payload,
          content:
            updatedMessages[idx].payload.content + newMessage.payload.content,
        },
      };
    }
  });

  return updatedMessages;
};
